import { render, staticRenderFns } from "./CreateOrUpdate.vue?vue&type=template&id=9c842d98&scoped=true&"
import script from "./CreateOrUpdate.vue?vue&type=script&lang=js&"
export * from "./CreateOrUpdate.vue?vue&type=script&lang=js&"
import style0 from "./CreateOrUpdate.vue?vue&type=style&index=0&id=9c842d98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c842d98",
  null
  
)

export default component.exports